import InteractiveUSMap from '@root/joinroot.com/src/components/covid-driving/map-section/interactive-us-map';
import PropTypes from '@root/vendor/prop-types';
import Responsive from '@root/core/src/utils/responsive';
import { H2, P1 } from '@root/gatsby-contentful-core/src/components/text';
import { METRICS } from '@root/joinroot.com/src/components/covid-driving/';
import { StyleSheet } from '@root/core/src/utils/styles';

export default function CovidDrivingMap({
  dataToDisplay,
  metric,
  startDate,
}) {
  const METRIC_HEADLINES = {
    [METRICS.TRIP_MILES]: 'Miles driven per day',
    [METRICS.TRIP_COUNT]: 'Trips taken per day',
    [METRICS.TRIP_MINUTES]: 'Time spent driving',
  };

  return (
    <section css={styles.section}>
      <div css={styles.headingContainer}>
        <H2 css={styles.headline}>{METRIC_HEADLINES[metric]}</H2>
        <P1 css={styles.subhead}>As the national response to COVID has evolved, many states have seen sharp declines in driving. Since the beginning of March, we’ve analyzed nearly 100 million trips comprising more than 780 million miles, and have seen marked changes in the average daily number of miles driven, trips taken, and time spent driving.</P1>
      </div>
      <InteractiveUSMap
        dataToDisplay={dataToDisplay}
        startDate={startDate}
      />
    </section>
  );
}

CovidDrivingMap.propTypes = {
  dataToDisplay: PropTypes.any,
  endDate: PropTypes.instanceOf(Date),
  metric: PropTypes.string,
  metricUnits: PropTypes.string,
  startDate: PropTypes.instanceOf(Date),
};

const styles = StyleSheet.create({
  section: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '80px 20px',
    ...Responsive.md({
      padding: '100px 20px',
    }),
  },
  headingContainer: {
    paddingLeft: 20,
    paddingRight: 20,
    maxWidth: 460,
    textAlign: 'center',
    boxSizing: 'content-box',
    ...Responsive.md({
      maxWidth: 700,
    }),
  },
  headline: {
    marginBottom: 15,
    ...Responsive.md({
      marginBottom: 50,
    }),
  },
  subhead: {
    marginBottom: 30,
    ...Responsive.md({
      marginBottom: 50,
    }),
  },
});
